import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Typography, Link, Box } from "@mui/material";

import appStoreIcon from "../../img/AppStore.svg";
import playStoreIcon from "../../img/GooglePlay.svg";
import { TERMS_AND_CONDITION, PRIVACY_POLICY_ROUTE } from "../../Auth/Routes";
import {
  mainLinksName,
  mobileAppLinks,
  socialIconsArray,
} from "../../consts/footerConstants";
import { styles } from "./FooterStyles";
const StoreBadge = ({ icon, topText, bottomText, href, alt }) => (
  <Link underline="none" href={href} target="_blank">
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
        border: "1.5px solid white",
        borderRadius: "8px",
        padding: "3px 3px",
        minWidth: "125px",
        color: "white",
      }}
    >
      <Box
        component="img"
        src={icon}
        alt={alt}
        sx={{
          width: 34,
          height: 34,
          objectFit: "contain",
          filter: "brightness(0) invert(1)",
        }}
      />
      <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
        <Typography
          sx={{
            fontSize: "9px",
            fontWeight: 400,
            letterSpacing: "0.02em",
            lineHeight: 1.2,
            whiteSpace: "nowrap",
            color: "white",
          }}
        >
          {topText}
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: 1.3,
            whiteSpace: "nowrap",
            color: "white",
          }}
        >
          {bottomText}
        </Typography>
      </Box>
    </Box>
  </Link>
);
const Footer = () => {
  const { t } = useTranslation();
  const language = useSelector((state) => state.languageChange.language);

  return (
    <Box sx={styles.footer}>
      <Box sx={styles.footerContainer}>
        <Box sx={styles.rootContainer}>
          <Box sx={styles.appIconContainer}>
            <StoreBadge
              icon={playStoreIcon}
              topText={t("footer.availableOn")}
              bottomText={t("footer.googlePlay")}
              href={mobileAppLinks.playStore}
              alt="Google Play Store"
            />
            <StoreBadge
              icon={appStoreIcon}
              topText={t("footer.downloadOn")}
              bottomText={t("footer.appStore")}
              href={mobileAppLinks.appStore}
              alt="Apple App Store"
            />
          </Box>

          <Box sx={styles.copyRightColumnStyles}>
            <Typography sx={{ ...styles.copyRightText }}>
              © CarePulse, LLC
            </Typography>
            <Box sx={styles.divider} />
            <Link
              underline="none"
              href={`/${language}/privacy-policy`}
              target="_blank"
            >
              <Typography
                sx={{ ...styles.copyRightText, ...styles.mainLinksText }}
              >
                {t(mainLinksName.privacyPolicy)}
              </Typography>
            </Link>
            <Box sx={styles.divider} />
            <Link
              underline="none"
              href={`/${language}/terms-and-conditions`}
              target="_blank"
            >
              <Typography
                sx={{ ...styles.copyRightText, ...styles.mainLinksText }}
              >
                {t(mainLinksName.termsOfService)}
              </Typography>
            </Link>
          </Box>

          <Box sx={styles.socialIconsBox}>
            {socialIconsArray.map((socialIcon, idx) => (
              <Link
                key={idx}
                underline="none"
                href={socialIcon.link}
                target="_blank"
                aria-label={socialIcon.name}
              >
                {socialIcon.svg ? (
                  <Typography
                    component="img"
                    src={socialIcon.svg}
                    alt={socialIcon.name}
                    width={22}
                    height={22}
                  />
                ) : (
                  <socialIcon.icon
                    sx={{
                      ...styles.socialIcons,
                      ...(socialIcon.name === "Twitter"
                        ? styles.twitterIcon
                        : {}),
                    }}
                  />
                )}
              </Link>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
